import { render } from "./NewRoleComponent.vue?vue&type=template&id=4f1c7530"
import script from "./NewRoleComponent.vue?vue&type=script&lang=js"
export * from "./NewRoleComponent.vue?vue&type=script&lang=js"
script.render = render

export default script